export default function soundcloud() {
  return {
    restrict: 'E',
    scope: {
      content: '=',
    },
    template:
      '<div ng-repeat="url in urls"><iframe src="{{ url }}" width="100%" height="100" scrolling="no" frameborder="no"></iframe></div>',
    link(scope) {
      scope.urls = [];
      if (scope.content?.length) {
        const matches = scope.content.match(/http(s?):\/\/soundcloud.com\/[\w-]+\/[\w-]+/g);
        if (matches) {
          scope.urls = matches.map((urlArg) => {
            const url = encodeURIComponent(urlArg.replace('https', 'http'));
            return `https://w.soundcloud.com/player/?url=${url}`;
          });
        }
      }
    },
  };
}
